import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, concatMap, delay, map, switchMap, tap } from 'rxjs/operators';

import { CompanyHttpService } from '@core/http/company.http.service';

import { SnackbarService } from '@shared/snack-bar/snack-bar.service';
import { parseError } from '@state/errors.parser';
import * as routerActions from '@state/router/router.actions';
import * as managerActions from './manager.actions';
import { RouterFacade } from '@state/router';
import { ManagerHttpService } from '@core/http/manager.http.service';

@Injectable()
export class ManagerEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly managerHttp: ManagerHttpService,
    private readonly snackService: SnackbarService,
    private readonly routerFacade: RouterFacade
  ) {}

  getMyManagedCompanies$ = createEffect(() =>
    this.actions$.pipe(
      ofType(managerActions.getMyManagedCompanies),
      switchMap(() => {
        return this.managerHttp.getMyManagedCompanies().pipe(
          map(managedCompanies => managerActions.getMyManagedCompaniesSuccess({ managedCompanies })),
          catchError(error => {
            const errorMessage = parseError(error, managerActions.getMyManagedCompanies.type);
            this.snackService.showError('MANAGER.ERROR_FETCHING_LIST_OF_MANAGED_COMPANIES');
            return of(managerActions.getMyManagedCompaniesError({ errorMessage }));
          })
        );
      })
    )
  );

  searchProcessesOfManagedEmployees$ = createEffect(() =>
    this.actions$.pipe(
      ofType(managerActions.searchProcessesOfManagedEmployees),
      switchMap(({ opts }) => {
        const { all, count, ...payload } = opts;
        return this.managerHttp.searchProcessesOfManagedEmployees(payload).pipe(
          map(processes => managerActions.searchProcessesOfManagedEmployeesSuccess({ processes })),
          catchError(error => {
            const errorMessage = parseError(error, managerActions.searchProcessesOfManagedEmployees.type);
            this.snackService.showError('MANAGER.ERROR_SEARCHING_PROCESSES');
            return of(managerActions.searchProcessesOfManagedEmployeesError({ errorMessage }));
          })
        );
      })
    )
  );
}
